/**
 * Passwords
 */
export const PASSWORDS_DO_NOT_MATCH = "Las contraseñas no coinciden";
export const PASSWORD_TOO_SHORT = "La contraseña es demasiado corta";
export const PASSWORD_TOO_LONG = "La contraseña es demasiado larga";
export const PASSWORD_REQUIRED = "La contraseña es obligatoria";

/**
 * Email
 */
export const EMAIL_INVALID = "El email no es valido";
export const EMAIL_REQUIRED = "El email es obligatorio";
